import { useAlert } from 'dashboard/composables';

export default {
  methods: {
    showAlert(message, type = 'success') {
      useAlert(message, type);
    },
  },
};
